import script from "./imageBox.vue?vue&type=script&setup=true&lang=js"
export * from "./imageBox.vue?vue&type=script&setup=true&lang=js"

import "./imageBox.vue?vue&type=style&index=0&id=864f0026&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-864f0026"]])

export default __exports__